<template>
    <div class="com-codics-hbb-order-admin-log-body">
        <div class="com-codics-hbb-order-admin-log-bar-content">
            <el-date-picker class="com-codics-hbb-order-admin-log-bar-input" style="margin-right: 15px;"
                v-model="timeData" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="listLogsFuc"
                value-format="timestamp">
            </el-date-picker>
            <el-input class="com-codics-hbb-order-admin-log-bar-input" v-model="searchTxt"
                placeholder="请输入要员工信息/方法/参数进行搜索..." clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="searchLogs">&#xe86e;
            </MyButton>
            <MyButton style="float: right;">&#xe854; 导出记录</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的用户数据吗？" @confirm="deleteUsersFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
        </div>
        <div class="com-codics-hbb-order-admin-log-bar-content com-codics-hbb-order-admin-log-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50">
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80" style="user-select: none;">
                </el-table-column>
                <el-table-column prop="label" label="员工账号" width="180">
                    <template slot-scope="scope">
                        <el-image style="height: 30px;width: 30px;position: relative;float: left;"
                            :src="scope.row?.account?.himg == null ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : scope.row?.account?.himg"
                            fit="fill">
                        </el-image>
                        <div style="margin-top: 5px;position: relative;float: left;margin-left: 5px;">{{
                            scope.row?.account?.nickname }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="operation" label="员工操作" width="220">
                </el-table-column>
                <el-table-column prop="method" label="调用方法" width="180">
                </el-table-column>
                <el-table-column prop="params" label="方法参数" width="104">
                    <template slot-scope="scope">
                        <el-popover placement="right" width="200" style="height: fit-content;" trigger="click">
                            <tbody class="codics-log-params-info">
                                <tr>
                                    <td>属性名</td>
                                    <td>属性值</td>
                                </tr>
                                <tr v-for="(item, index) in paramsData" :key="index">
                                    <td>{{ item.key }}</td>
                                    <td>{{ item.value }}</td>
                                </tr>
                            </tbody>
                            <el-button slot="reference" @click="handleParams(scope.row.params)"
                                type="mini">查看参数</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="ip" label="IP地址" width="230">
                </el-table-column>
                <el-table-column align="right" prop="createtime" label="操作时间" min-width="250">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.createtime) }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import { listLogs } from '@/api';
export default {
    data() {
        return {
            tableData: [],
            searchData: [],
            selectData: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            timeData: [],
            paramsData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
            },
        }
    },
    components: {
        MyButton
    },
    mounted() {
        this.listLogsFuc();
    },
    methods: {
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listUsersFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listUsersFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        addUserCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchLogs() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listLogsFuc();

        },
        handleParams(data) {
            let json = JSON.parse(data);
            let t = [];
            for (let item in json) {

                t.push({
                    key: item,
                    value: json[item]
                });

            }

            this.paramsData = t;
        },
        async listLogsFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listLogs({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                from: this.timeData == null ? null : this.timeData[0],
                to: this.timeData == null ? null : this.timeData[1]
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        async repassUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listUsersFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listUsersFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-log-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

.com-codics-hbb-order-admin-log-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-log-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-log-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-log-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}
</style>